import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default class PublicidAboutRoute extends Route {

  pageId() {
    return this.modelFor('app.publicid').page?.id;
  }

  id() {
    return this.modelFor('app.publicid').uuid;
  }

  beforeModel() {
    if (this.pageId()) {
      this.set('theme', Theme.PAGE);
    } else {
      this.set('theme', Theme.PROFILE);
    }
  }

  model() {
    if (this.pageId()) {
      return {
        app: this.modelFor('app'),
        appPage: this.modelFor('app.publicid'),
      };
    } else {
      return {
        app: this.modelFor('app'),
        appProfile: this.modelFor('app.publicid'),
      };
    }
  }
}
